import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { LocationType } from "__generated__/enums";
import { getLocationTypeColor } from "view/locations/utils/LocationUtils";

const LocationTypeSelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<LocationType, Multiple>, "fetchOptions" | "paginated" | "getOptionLabel" | "getOptionColor">) => {
	return (
		<Select
			fetchOptions={Object.values(LocationType)}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			getOptionColor={option => getLocationTypeColor(option)}
			{...rest} />
	);
};

export default LocationTypeSelect;
